import { ButtonSize } from '@accredible-frontend-v2/new-components/button';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'accredible-button-filter',
  templateUrl: './button-filter.component.html',
  styleUrls: ['./button-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccredibleButtonFilterComponent implements AfterViewInit {
  @Input()
  size: ButtonSize = 'small';
  @Input()
  icon: string;
  @Input()
  selected = false;
  @Input()
  rotateIcon = true;
  @Input()
  closeMenuOnClick = true;
  @Input()
  menuWidthEqualsButtonWidth = false;
  @Input()
  disabled = false;

  @Output()
  menuToggle = new EventEmitter<boolean>();

  @ViewChild('buttonFilterElement', { read: ElementRef })
  buttonFilterElement: ElementRef<HTMLElement>;

  menuOpened = false;
  menuWidth = 'auto';

  @HostListener('window:resize')
  onResize(): void {
    if (this.menuWidthEqualsButtonWidth) {
      // 20 is the size of the padding of the accredible-menu-content
      this.menuWidth = `${this.buttonFilterElement.nativeElement.clientWidth - 20}px`;
    }
  }

  ngAfterViewInit(): void {
    this.onResize();
  }

  onMenuToggle(isOpen: boolean): void {
    this.menuOpened = isOpen;
    this.menuToggle.emit(this.menuOpened);
  }
}
